/* eslint-disable */

export default () => {
    // 获取透传utm_source utm_medium
    var utm_source = getQuery("utm_source"),
        utm_medium = getQuery("utm_medium"),
        referrer = (localStorage.referrer = document.referrer);
    utm_source
        ? (localStorage.utm_source = utm_source)
        : !localStorage.utm_source
        ? (localStorage.utm_source = getSource())
        : "";

    utm_medium
        ? (localStorage.utm_medium = utm_medium)
        : !localStorage.utm_medium
        ? (localStorage.utm_medium = getMedium())
        : "";
    localStorage.referrer = referrer;

    function getQuery(key) {
        var location = window.location;
        var queryArr = location.search.replace(/^\?/, "").split("&");
        var queryObj = {};
        var queryLen = queryArr.length;
        if (queryLen > 0) {
            for (var i = 0; i < queryLen; i++) {
                var kv = queryArr[i].split("=");
                queryObj[kv[0]] = kv[1];
            }
        }
        return queryObj[key];
    }

    function getSource() {
        var utm_source = "pc_",
            ua = navigator.userAgent;
        switch (true) {
            case !!referrer.match(/(baidu.com|sogou.com|so.com)/gi):
                utm_source = "sem";
        }
        return utm_source;
    }
    function getMedium() {
        var utm_medium = "",
            ua = navigator.userAgent,
            referrer = document.referrer;
        switch (true) {
            case !!ua.match(/micromessenger/gi):
                if (getSource("from") === "timeline") {
                    utm_medium = "moment";
                } else {
                    utm_medium = "wechat";
                }
                break;
            case !!ua.match(/weibo/gi):
                utm_medium = "weibo";
                break;
            case !!ua.match(/QQ/gi):
                utm_medium = "qq";
                break;
            case !!referrer.match(/baidu/gi):
                utm_medium = "baidu";
                break;
            case !!referrer.match(/sogou/gi):
                utm_medium = "soso";
                break;
            case !!referrer.match(/so/gi):
                utm_medium = "360";
                break;
            case !!ua.match(/Safari/gi):
                utm_medium = "safari";
                break;
            case !!ua.match(/Chrome/gi):
                utm_medium = "chrome";
                break;
            case !!ua.match(/Firefox/gi):
                utm_medium = "firefox";
                break;
            case !!ua.match(/Opera/gi):
                utm_medium = "opera";
                break;
            case !!ua.match(/compatible/gi) ||
                !!ua.match(/MSIE/gi) ||
                !!ua.match(/Edge/gi):
                utm_medium = "ie";
                break;
        }
        return utm_medium;
    }
};
